import { BottomNav } from "./Bottom_nav";
import { MiddleLogoDiv } from "./Middle_logo_div";
import { TopImageDiv } from "./Top_image";

export const Navbar = () => {
  return (
    <>
      <BottomNav></BottomNav>
    </>
  );
};
